import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import './TestingReport.scss';
import { Grid, Paper, TextField } from '@mui/material';
import { formatDate } from 'src/utils/utils';
import variables from 'src/style/variable/variables.module.scss';
import CancelIcon from '@mui/icons-material/CancelSharp';
import CheckCircleIcon from '@mui/icons-material/CheckCircleSharp';
import { useTranslation } from 'src/i18n';
import { RECOMMENDATIONS_MAX_LENGTH } from 'src/utils/constants';
export default function FinalizeAndSignOff ({
  onChange,
  data,
  readOnly,
  passed,
  showPassFail,
  notesLabel,
  notesValue,
  notesPath
} ) {
  const { t } = useTranslation();

  const user: any = useSelector((state: any) => state.authentication.get('user'));
  const onComment = (field, val) => {
    onChange(['signOff', field], val);
  };

  // By default the notes box is the report's recommendations, stored in the 255-char
  // check_sheet_report.notes column. A report can point it at an extras path instead, which
  // is jsonb and so uncapped — the counter and maxLength only apply to the capped column.
  const useRecommendations = !notesPath;
  const notesText = (useRecommendations ? data?.get('recommendations') : notesValue) || '';
  const capped = useRecommendations
    ? { inputProps: { maxLength: RECOMMENDATIONS_MAX_LENGTH },
      error: notesText.length >= RECOMMENDATIONS_MAX_LENGTH,
      helperText: t('common.charactersCount', { current: notesText.length, max: RECOMMENDATIONS_MAX_LENGTH }),
      FormHelperTextProps: { sx: { textAlign: 'right', margin: 0 } } }
    : {};

  return (
    <Paper className='finalize-container'>
      <Grid container>
        <Grid item xs={12} sm={showPassFail ? 4 : 8}><b>{t('testingReport.signOff.verifiedBy')}</b> {user.get('first_name', null)} {user.get('last_name', null)}</Grid>
        <Grid item xs={12} sm={4}><b>{t('testingReport.signOff.createdAt')}</b> {formatDate(new Date())}</Grid>
        {showPassFail  &&<Grid item xs={12} sm={4}>
          {
            passed ? <>
              <CheckCircleIcon style={{ color: variables.success, fontSize: 24, position: 'absolute' }} />
              <b style={{ marginLeft: '30px' }}>{t('common.passed')} </b></>
              :
              <>
                <CancelIcon style={{ color: variables.error, fontSize: 24, position: 'absolute' }} />
                <b style={{ marginLeft: '30px' }}>{t('common.failed')} </b>
              </>
          }


        </Grid>}

        <Grid item xs={12}>
          <TextField
            multiline
            rows={8}
            fullWidth
            value={notesText}
            disabled={readOnly}
            label={notesLabel || t('testingReport.signOff.recommendations')}
            onChange={(e) => {
              if (useRecommendations) onComment('recommendations', e.target.value);
              else onChange(notesPath, e.target.value);
            }}
            {...capped}
          />
        </Grid>

      </Grid>
    </Paper>

  );
}

FinalizeAndSignOff.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  passed: PropTypes.bool,
  showPassFail: PropTypes.bool,
  // Retitle the notes box, e.g. when a report uses it for something other than recommendations.
  notesLabel: PropTypes.string,
  // Point the notes box at an extras path instead of the capped signOff.recommendations.
  // Supply notesValue alongside it.
  notesPath: PropTypes.array,
  notesValue: PropTypes.string,
};
FinalizeAndSignOff.defaultProps = {
  showPassFail: false,
  passed: false,
};
